import { Serializable } from "@/core/generated/api/decorators/serializable_decorator"
import { ActivityEventType } from "@/modules/activity/constants/activityEventType"

@Serializable
export class ActivityEventItem {
  uid: string = ""
  firstname: string = ""
  lastname: string = ""
  role: string = ""
  create_at: string = ""
  title: string = ""
  description: string = ""
  link: string = ""
  eventType: ActivityEventType = ActivityEventType.NotDefined

  constructor(data?: Partial<ActivityEventItem> | null) {
    Object.assign(this, data)
  }
}
